import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/ping.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm ping
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/ping.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Ping the configured or given npm registry and verify authentication.
If it works it will output something like:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm notice PING https://registry.npmjs.org/
npm notice PONG 255ms
`}</code></pre>
    <p>{`otherwise you will get an error:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm notice PING http://foo.com/
npm ERR! code E404
npm ERR! 404 Not Found - GET http://www.foo.com/-/ping?write=true
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-doctor"
        }}>{`npm doctor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/npmrc"
        }}>{`npmrc`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      